var _path, _g, _path2, _circle, _circle2, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListOfWfStepsPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 101,
    viewBox: "0 0 125 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105 100.7L20.0003 100.7C9.12033 100.7 0.300361 91.88 0.30036 81L0.300356 15.0429L124.7 15.0429L124.7 81C124.7 91.88 115.88 100.7 105 100.7Z",
    fill: "white",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3249_3877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9848 73.8456L34.9851 73.8453C35.5075 73.4446 36.1606 73.2068 36.8712 73.2068H77.1015C78.8172 73.2068 80.2084 74.598 80.2084 76.3137V83.4056C80.2084 85.1223 78.8171 86.5134 77.1015 86.5134H36.8712C35.1556 86.5134 33.7647 85.1223 33.7647 83.4056V76.3137C33.7647 75.3083 34.2419 74.4145 34.9848 73.8456Z",
    fill: "#EBF2F9",
    stroke: "#D2DBE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3654 48.7012V65.3247C84.3654 66.7678 83.1968 67.9365 81.755 67.9365H51.5068C50.0639 67.9365 48.8951 66.7676 48.8951 65.3247V48.7012C48.8951 47.2594 50.0637 46.0908 51.5068 46.0908H81.755C83.197 46.0908 84.3654 47.2592 84.3654 48.7012Z",
    fill: "#EBF2F9",
    stroke: "#D2DBE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8313 45.5908V68.2294L53.8039 68.4365H51.5068C49.7878 68.4365 48.3951 67.0438 48.3951 65.3247V48.7012C48.3951 46.9831 49.7878 45.5908 51.5068 45.5908H53.8313Z",
    fill: "#D8E1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.709 28.8974L41.709 28.8974L41.7099 28.8969C42.0341 28.7171 42.4069 28.6152 42.8062 28.6152H71.3726C72.6287 28.6152 73.6468 29.6333 73.6468 30.8894V38.3639C73.6468 39.6192 72.6286 40.6381 71.3726 40.6381H42.8062C41.5498 40.6381 40.532 39.6193 40.532 38.3639V30.8894C40.532 30.0321 41.0055 29.2856 41.709 28.8974Z",
    fill: "#EBF2F9",
    stroke: "#D2DBE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3933 48.8906H57.0655C56.5699 48.8906 56.1684 49.2921 56.1684 49.7877C56.1684 50.2833 56.5699 50.6849 57.0655 50.6849H80.3933C80.8884 50.6849 81.2904 50.2833 81.2904 49.7877C81.2904 49.2921 80.8889 48.8906 80.3933 48.8906Z",
    fill: "#D8E1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3933 53.7075H57.0655C56.5699 53.7075 56.1684 54.109 56.1684 54.6046C56.1684 55.1002 56.5699 55.5022 57.0655 55.5022H80.3933C80.8884 55.5022 81.2904 55.1002 81.2904 54.6046C81.2904 54.109 80.8889 53.7075 80.3933 53.7075Z",
    fill: "#D8E1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3933 58.5244H57.0655C56.5699 58.5244 56.1684 58.9259 56.1684 59.4215C56.1684 59.9171 56.5699 60.3191 57.0655 60.3191H80.3933C80.8884 60.3191 81.2904 59.9171 81.2904 59.4215C81.2904 58.9259 80.8889 58.5244 80.3933 58.5244Z",
    fill: "#D8E1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3933 63.3413H57.0655C56.5699 63.3413 56.1684 63.7428 56.1684 64.2384C56.1684 64.734 56.5699 65.136 57.0655 65.136H80.3933C80.8884 65.136 81.2904 64.734 81.2904 64.2384C81.2904 63.7428 80.8889 63.3413 80.3933 63.3413Z",
    fill: "#D8E1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3703 57.0445C46.3703 56.5485 45.9684 56.1469 45.4728 56.1469H36.9949C35.7818 56.1469 34.7942 55.1598 34.7942 53.9467V37.8872C34.7942 36.6737 35.7818 35.6865 36.9949 35.6865C37.4905 35.6865 37.8921 35.285 37.8921 34.7894C37.8921 34.2938 37.4905 33.8918 36.9949 33.8918C34.792 33.8918 33 35.6843 33 37.8872V53.9467C33 56.1492 34.792 57.9416 36.9949 57.9416H45.4732C45.9684 57.9416 46.3703 57.5396 46.3703 57.0445Z",
    fill: "#D8E1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9839 37.7656H69.1949C69.6905 37.7656 70.092 37.3637 70.092 36.8681C70.092 36.3725 69.6905 35.9709 69.1949 35.9709H44.9839C44.4883 35.9709 44.0864 36.3725 44.0864 36.8681C44.0864 37.3637 44.4883 37.7656 44.9839 37.7656Z",
    fill: "#D8E1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9839 33.2818H69.1949C69.6905 33.2818 70.092 32.8803 70.092 32.3847C70.092 31.8891 69.6905 31.4875 69.1949 31.4875H44.9839C44.4883 31.4875 44.0864 31.8891 44.0864 32.3847C44.0864 32.8803 44.4883 33.2818 44.9839 33.2818Z",
    fill: "#D8E1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.564 81.2046H38.0946C37.599 81.2046 37.1975 81.6061 37.1975 82.1017C37.1975 82.5973 37.599 82.9993 38.0946 82.9993H67.5636C68.0592 82.9993 68.4607 82.5973 68.4607 82.1017C68.4607 81.6061 68.0592 81.2046 67.564 81.2046Z",
    fill: "#D8E1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.564 76.7212H38.0946C37.599 76.7212 37.1975 77.1227 37.1975 77.6183C37.1975 78.1139 37.599 78.5154 38.0946 78.5154H67.5636C68.0592 78.5154 68.4607 78.1139 68.4607 77.6183C68.4607 77.1227 68.0592 76.7212 67.564 76.7212Z",
    fill: "#D8E1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1684 54.6287C87.6729 54.6287 87.2713 55.0302 87.2713 55.5258C87.2713 56.0214 87.6729 56.4233 88.1684 56.4233C89.292 56.4233 90.2058 57.3371 90.2058 58.4602V76.9256C90.2058 78.0487 89.2915 78.9625 88.1684 78.9625H84.011C83.5154 78.9625 83.1139 79.364 83.1139 79.8596C83.1139 80.3552 83.5154 80.7567 84.011 80.7567H88.1684C90.2814 80.7567 92 79.0381 92 76.9256V58.4602C92 56.3477 90.2814 54.6287 88.1684 54.6287Z",
    fill: "#D8E1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8084 75.4468C76.3975 75.17 75.8397 75.2789 75.5629 75.6899L72.272 80.5765L71.1822 78.9583C70.9054 78.5469 70.3477 78.4384 69.9367 78.7152C69.5257 78.9921 69.4168 79.5498 69.6936 79.9603L71.5279 82.6841C71.6945 82.9316 71.9735 83.0802 72.272 83.0802C72.5704 83.0802 72.8495 82.9316 73.016 82.6841L77.0515 76.6923C77.3279 76.2814 77.2194 75.7236 76.8084 75.4468Z",
    fill: "#D8E1E8"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0818 0.3L108.918 0.3C117.534 0.3 124.537 7.20421 124.697 15.7818L0.302794 15.7818C0.462709 7.20421 7.46598 0.3 16.0818 0.3Z",
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9649,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2748,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5847,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3249_3877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white",
    transform: "translate(33 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListOfWfStepsPlaceholder);
export default __webpack_public_path__ + "static/media/list-of-wf-steps-placeholder.01a9e32d54c79d3ae302b8b11ba093d3.svg";
export { ForwardRef as ReactComponent };